import { render, staticRenderFns } from "./ShiJi.vue?vue&type=template&id=5f22dc0d&scoped=true"
import script from "./ShiJi.vue?vue&type=script&lang=js"
export * from "./ShiJi.vue?vue&type=script&lang=js"
import style0 from "./ShiJi.vue?vue&type=style&index=0&id=5f22dc0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22dc0d",
  null
  
)

export default component.exports